import { Checkbox } from '../Checkbox';
import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { handleLinkClick } from '../../utils/linkHandler';

type TPolicyAgreementLinks = {
  personalDataProcessingPolicyUrl: string;
  agreementRecommendationUrl?: string;
  confidentialityPolicyUrl?: string;
};

type TProps = Omit<React.ComponentProps<typeof Checkbox>, 'label'> & TPolicyAgreementLinks;

const CONFIDENTIALITY_POLICY_URL = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_0';

export const AgreementCheckbox: React.FC<TProps> = props => {
  /**
   * Делает искусственный переход по ссылке,
   * сохраняя состояние чекбокса
   */

  const agreementUrl = props.agreementRecommendationUrl
    ? props.agreementRecommendationUrl
    : props.personalDataProcessingPolicyUrl;

  return (
    <Checkbox
      id={props.id}
      isError={props.isError}
      isChecked={props.isChecked}
      setChecked={props.setChecked}
      isDisabled={props.isDisabled}
      label={
        <UIText1>
          {'Соглашаюсь на '}
          <a
            href={agreementUrl}
            className={styles['agreement-link']}
            target="_blank"
            rel="noreferrer"
            onClick={e => handleLinkClick(e, agreementUrl)}
          >
            <UIText1 color="text-main-default" display="inline">
              обработку персональных данных
            </UIText1>
          </a>
          {' в соответствии с '}
          <a
            href={props.confidentialityPolicyUrl || CONFIDENTIALITY_POLICY_URL}
            className={styles['agreement-link']}
            target="_blank"
            rel="noreferrer"
            onClick={e => handleLinkClick(e, props.confidentialityPolicyUrl || CONFIDENTIALITY_POLICY_URL)}
          >
            <UIText1 color="text-main-default" display="inline">
              политикой конфиденциальности
            </UIText1>
          </a>
        </UIText1>
      }
    />
  );
};
